const workflows = {
  workflow_history: `Workflow history`,
  workflow_updated: `Workflow updated`,
  new_workflow: `New workflow`,
  old_workflow: `Old workflow`,
  workflow_change_logs: `Workflow change logs`,
  assign_workflow: `Assign workflow`,
  assign_workflow_to_organization_users: `Assign this document workflow to users of your organization`,
  assign_supplier_to_organization_users: `Assign this supplier workflow to users of your organization`,
  approvers: `Approvers`,
  add_a_new_email: `Add a new email`,
  assign: `Assign`,
  workflow_doc_pending_approval: `Workflow document approval pending`,
  workflow_doc_deleted: `Workflow document deleted`,
  workfow_doc_approvalnotrequired_attached: `Workflow document approval not required attached`,
  workflow_assigned_successfully: `Workflow assigned successfully`,
  workflow_doc_not_classified: `This document's account class and document class one of this are not classified`,
  workflow_doc_purchase_requisition_id_missing: `This requisition document has no linked purchase requisition`,
  you_do_not_have_any_workflows_yet: `You do not have any workflows yet`,
  no_workflows_found_for_the_selected_filters: `No workflows found for the selected filters`,
  approve: "Approve",
  reject: "Reject",
  approvalRequired: "Approval Required",
  approved: "Approved",
  rejected: "Rejected",
  reviewRequired: "Review Required",
  pending_approval: `Pending Approval`,
  approval_not_required: `Approval not required`,
  workflow_documents_pending_approval: `Workflow document pending approval`,
  approval_status: `Approval status`,
  workflow_details: `Workflow details`,
  workflow_docstatus_duplicate: `Workflow cannot be assigned to duplicate document`,
  workflow_docstatus_earlyduplicate: `Workflow cannot be assigned to duplicate document`,
  reassign_workflow: `Reassign workflow`,
  reassign_workflow_to_organization_users: `Reassign workflow to other user(s)`,
  approvers_required: `Approver is required`,
  reason_is_required: `Reason is required`,
  reassign: `Reassign`,
  workflow_reassigned_successfully: `Workflow reassigned successfully`,
  reason_max_length_validation: `Reason cannot be more than 100 characters`,
  isWorkflowApproverTriggeredOncePerDocument: `Automated workflows are executed only once per document `,
  isWorkflowApproverTriggeredOncePerDocument_hover_text: `Workflows triggered by the document's field "workflow approver"`,
  isReviewNotAllowedAfterDocumentWorkflowApproval:
    "Disable Document Review After Workflow is Approved",
  workflow_configuration: `Workflow Configuration`,
  disable_email_notification_status: `Disable email notification status`,
  workflow_approver_email_notification: `Enable email notifications for approvers`,
  workflow_configurations_updated: `Workflow configuration updated successfully`,
  workflow_reason_maxLength: `Reason must be at most 100 characters`,
  enablePendingApprovalReminderEmailNotification:
    "Turn on email reminders for documents awaiting approval (Daily)",
  isApprovalReasonMandatory: "Approval reason is mandatory",
  isAssignReasonMandatory: "Assignment reason is mandatory",
  isRejectionReasonMandatory: "Rejection reason is mandatory",
  skipWorkflowRetriggerOnDocReviewWhenPendingApproval:
    "Skip workflow retrigger on document review when pending approval",
  skipWorkflowRetriggerOnDocReviewWhenPendingApproval_hover_text:
    "When a document is already pending approval, reviewing it again will not retrigger the workflow.",
  disableEmailAlertOnDocApprovalRequired: `Disable email alert when document approval is required`,
  disableEmailAlertOnDocApprovalRequired_hover_text: `When enabled, approvers will not receive an email alert when a document requires their approval.`,
  assignment_reason: `Assignment reason`,
  allowAprovalOnProcessedOrReviewedDocument: `Allow approval on "processed" or "reviewed" documents only`,
  allowAprovalOnProcessedOrReviewedDocument_hover_text: `Documents with "need review" status will not be approved`,
  ignoreWorkflowExecutionOnDuplicateDocument_hover_text: `After extraction, if a document is identified as a duplicate, the workflow will not be executed.`,
  supplier_not_found: "Supplier not found",
  supplier_is_deleted: "Supplier is deleted",
  workflow_reason_required:
    "Please provide a reason for assigning the workflow",
  failed_to_fetch_supplier_approval_version_id:
    "Failed to fetch supplier approval version ID",
  failed_to_fetch_document_workflow_approval_version_id: `Failed to fetch document worfklow approval version ID`,
  assign_workflow_when_supplier_is_created: `Assign workflow when supplier is created`,
  configure_default_supplier_workflow: `Configure default supplier workflow`,
  configure_default_supplier_workflow_hover_text: `Trigger workflow when supplier is created/update (request sent to configured approvers)`,
  bulk_workflow_first_text: `Download our sample CSV template for workflow.`,
  upload_bulk_workflows: `Upload bulk workflows`,
  download_workflows: `Download workflows`,
  bulk_workflow_upload: `Bulk workflows upload`,
  ignoreWorkflowExecutionOnDuplicateDocument: `Prevent workflow "assignment" or "execution" on duplicate document`,
  "workflow-reason-required": `Reason is required`,
  workflow_not_found: `Workflow not found`,
  download_workflow: `Download workflow`,
  workflow_download_request_inprocess: `Workflow download request in process`,
  assign_workflow_via_template: `Assign this document to a role and stage in your workflow`,
  select_organization_role: `Select organization role`,
  select_stage: `Select stage`,
  role: `Role`,
  stage: `Stage`,
  description: `Description`,
  description_required: `Description is required`,
  organization_role_is_required: `Organization role is required`,
  enter_reason: `Enter reason`,
  select_approvers: `Select approvers`,
  reassign_to_new_approver: `Re-assign to new approver`,
  reassign_document_workflow_subtitle: `Re-assign this document workflow to users of your organization`,
  reassign_supplier_workflow_subtitle: `Re-assign this supplier workflow to users of your organization`,
  reason_max_length_1000: `Reason must be at most 1000 characters`,
  reject_document_subtitle: `Provide reason for rejecting document and if you want you can even specify a new approver`,
};

export default workflows;
